import type { HttpClient } from '@wix/cli-http-client';
import { CliError, CliErrorCode } from '@wix/cli-error';
import { createProject } from '@wix/ambassador-funnel-projects-v1-project/http';
import { Type } from '@wix/ambassador-funnel-projects-v1-project/types';
import { CreateProjectResponseSchema } from './schemas.js';

export class FunnelProjectsClient {
  constructor(private readonly httpClient: HttpClient) {}

  createProject = async (siteName: string, templateId: string) => {
    try {
      const { data } = await this.httpClient.request(
        createProject({
          name: siteName,
          templateId,
          type: Type.HEADLESS,
        })
      );

      return CreateProjectResponseSchema.parse(data);
    } catch (e) {
      throw new CliError({
        code: CliErrorCode.FailedCreatingNewFunnelProject(),
        cause: e,
      });
    }
  };
}
